import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DatasService} from '../../../services/datas.service';
import { OrderListModule } from 'primeng/orderlist';
import {DatePipe, DecimalPipe} from '@angular/common';
import {
    Component,
    Optional,
    Inject,
    Input,
    Output,
    ViewChild,
    OnInit,
    OnChanges,
    TemplateRef,
    EventEmitter
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'editable-field',
    templateUrl: './editable-field.component.html',
    styleUrls: ['./editable-field.component.scss'],
    host: {'[class]': 'widthClass'}
})
export class EditableFieldComponent implements OnInit {
    @Input() public label: string;
    @Input() public defaultValue: string;
    @Input() public placeholder: string = "";
    @Input() public widths: any;
    @Input() public fdef: any;
    @Input() public class: string;
    @Input() public widthClass: string;
    @Input() public object: any;
    @Input() public name: string;
    @Input() public itemTemplate: TemplateRef<any>;
    @Input() public allowedClass: string;
    @Input() public allowedClasses: string[];
    @Input() public searchBy: string[];
    @Input() public defaultFilter: any[];
    @Input() public formGroup: FormGroup;
    @Input() public validators: any;
    @Input() public required: boolean;
    @Input() public hrefSelect: boolean;
    @Input() public minDate: any;
    @Input() public disabled: boolean;
    @Input() public orderable: boolean;
    @Input() public addNumeric: boolean;
    @Input() public multiple: boolean = false;
    @Input() public valueNumeric: number;
    @Output() public update = new EventEmitter;
    suggestionsItems : any[] = [];
    displaySearch: boolean = false;
    lastSearch: string = "";
    curItemEditIndex;
    selectedItem;
    withFilter: boolean = false;
    fieldtype: string = "input";
    calendarLocal: any = {};
    focused: boolean = false;
    selectOptions: any[];
    value: any;
    originalValue: any;
    formControl: FormControl;
    visible: boolean = true;
    yearRange: string = (new Date().getFullYear() - 80) + ':' + (new Date().getFullYear() + 20);

  constructor(
    public datasService: DatasService,
    public decimalPipe: DecimalPipe,
    public http: HttpClient,
  ) {}

    trackItem(index, item) {
        return index;
    }

    addItem(classe?: string) {
        if (classe) {
            this.allowedClass = classe;
        }
        setTimeout(() => {
            if (this.fieldtype == "objects") {
                this.object[this.name].push({});
                this.curItemEditIndex = this.object[this.name].length - 1;
                this.displaySearch = true;
            } else if (this.fieldtype == "href") {
                this.displaySearch = true;
            }
        })
    }

    editItem(index) {
        this.curItemEditIndex = index;
        this.displaySearch = true
    }

    deleteItem(index) {
        this.object[this.name].splice(index, 1);
    }

    changeItem() {
        this.displaySearch = false;
        if (this.fieldtype == "objects") {
            if (Array.isArray(this.selectedItem)) {
                this.selectedItem.forEach((item) => {
                    this.object[this.name][this.curItemEditIndex] = item;
                    this.curItemEditIndex++;
                });
            } else {
                this.object[this.name][this.curItemEditIndex] = this.selectedItem;
            }
            this.selectedItem = null;
        } else if (this.fieldtype == "href") {
            if (this.hrefSelect) {
                this.object[this.name] = this.selectedItem;
            } else {
                this.object[this.name] = this.selectedItem;
                this.selectedItem = null;
            }
        }
        this.update.emit(true);
    }

    filterItems(event) {
        if (!event) {
            event = {query: this.lastSearch}
        } else {
            this.lastSearch = event.query;
        }
        let propSearch = this.searchBy[0];
        let otherProps : string[] = [];
        if (this.searchBy.length > 1) {
            for (let i = 1; i < this.searchBy.length; i++) {
                otherProps.push(this.searchBy[i]);
            }
        }
        if (!event.query) {
            return;
        }
        let filters = [{
            "operator": "LIKE",
            "value": event.query,
            "property": propSearch,
            "type": "string",
            "or": otherProps
        },
            {
                "operator": "=",
                "value": "1",
                "property": "actif",
                "type": "boolean",
            }];
        if (this.defaultFilter && this.defaultFilter.length > 0) {
            filters = [...filters, ...this.defaultFilter];
        }
        this.datasService.getList(this.allowedClass, {
            start: 0,
            limit: 20,
            filter: JSON.stringify(filters)
        }).then(data => {
            this.suggestionsItems = data.data;
        });
    }

    ngDoCheck() {
        if (this.object[this.name] != this.originalValue) {
            // console.log('ngdocheck :' + this.name);
            // console.log(this.object[this.name], this.originalValue);
            this.originalValue = this.object[this.name];
            switch (this.fieldtype) {
                case "date":
                    if (this.object[this.name]) {
                        this.value = new Date(this.object[this.name] * 1000);
                    } else {
                        this.value = false;
                    }
                    break;
                case "datetime":
                    if (this.object[this.name]) {
                        this.value = new Date(this.object[this.name] * 1000);
                    } else {
                        this.value = false;
                    }
                    break;
                case "href":
                    this.value = "";
                    if (this.object) {
                        this.value = this.object[this.name];
                    }
                    if (this.hrefSelect) {
                        this.selectedItem = this.value;
                    }
                    break;
                default:
                    this.value = "";
                    if (this.object) {
                        this.value = this.object[this.name];
                        if (this.defaultValue && !this.value && this.value != "") {
                            this.value = this.defaultValue;
                        }
                    }
                    break;
            }
            this.formControl.setValue(this.value);
        }
    }

    defineVisibility() {
        if (this.disabled == undefined) {
            if (this.fdef) {
                if ("classname" in this.fdef && "name" in this.fdef) {

                    // this.visible = this.permissions.isVisible(this.fdef["classname"], this.fdef["name"]);
                    // this.disabled = this.permissions.isDisabled(this.fdef["classname"], this.fdef["name"]);

                }
            }
        }
    }

    ngOnInit() {
        // if (this.object[this.name]) {
        //     this.originalValue = JSON.parse(JSON.stringify(this.object[this.name]));
        // } else {
        this.defineVisibility();

        this.originalValue = this.object[this.name];
        // }
        if (typeof this.required != "undefined") {
            this.required = true;
        } else {
            this.required = false;
        }
        this.calendarLocal = {
            firstDayOfWeek: 1,
            dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
            dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
            monthNames: ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"],
            monthNamesShort: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jui", "Jui", "Aou", "Sep", "Oct", "Nov", "Dec"],
            today: "Aujourd'hui",
            clear: 'Reset'
        };
        if (!this.widths) {
            this.widths = {
                "xs": 12,
                "sm": 12,
                "md": 4,
                "lg": 2
            }
        }
        if (!this.widthClass) {
            let wClasses : string[] = [];
            for (let i in this.widths) {
                if (this.widths[i]) {
                    wClasses.push("col-" + i + "-" + this.widths[i]);
                } else {
                    wClasses.push("col-" + i);
                }
            }
            this.widthClass = wClasses.join(" ");
        }
        if (this.fdef) {
            this.fieldtype = this.fdef.fieldtype;
            if (this.hrefSelect) {
                this.fieldtype = "href";
            }
            if (this.fieldtype == "select") {
                this.selectOptions = this.fdef.selectOptions;
                if (this.selectOptions.length > 10) {
                    this.withFilter = true;
                }
            }
            if (this.fieldtype == "gender") {
                let ret : Object[] = [];
                ret.push(
                    {label: '', value: false},
                    {label: this.fdef.prepOptions.female, value: 'female'},
                    {label: this.fdef.prepOptions.male, value: 'male'}
                );
                this.selectOptions = ret;
            }
            if (this.fieldtype == "multiselect") {
                let ret : Object[] = [];
                for (let o in this.fdef.options) {
                    ret.push({label: this.fdef.options[o]['key'], value: this.fdef.options[o]['value']});
                }
                this.selectOptions = ret;
            }
        }
        switch (this.fieldtype) {
            case "date":
            case "datetime":
                if (this.object[this.name]) {
                    this.value = new Date(this.object[this.name] * 1000);
                    if (this.minDate == "today") {
                        this.minDate = new Date();
                    } else {
                        this.minDate = this.minDate;
                    }
                } else {
                    if (this.minDate == "today") {
                        this.minDate = new Date();
                    } else {
                        this.minDate = this.minDate;
                    }
                    this.value = false;
                }
                break;
            case "href":
                this.value = "";
                if (this.object) {
                    this.value = this.object[this.name];
                }
                if (this.hrefSelect) {
                    this.selectedItem = this.value;
                }
                break;
            case "numeric":
                this.value = "";
                if (this.object) {
                    this.value = this.object[this.name];
                    if (this.defaultValue && !this.value && this.value != "") {
                        this.value = this.defaultValue;
                    }
                }
                if (this.addNumeric) {
                    this.value = this.value * 1 + this.valueNumeric * 1;
                }
                break;
            default:
                this.value = "";
                if (this.object) {
                    this.value = this.object[this.name];
                    if (this.defaultValue && !this.value && this.value != "") {
                        this.value = this.defaultValue;
                    }
                }

                break;
        }
        let valids: any[] = this.getValidators();
        this.formControl = new FormControl(this.value, valids);
        this.formControl.valueChanges.subscribe(val => {
            if (this.fieldtype == "date" || this.fieldtype == "datetime") {
                if (val) {
                    if (typeof val == "object") {
                        // console.log(val);
                        this.originalValue = val.getTime() / 1000;
                        this.object[this.name] = val.getTime() / 1000;
                    } else {
                        this.originalValue = "";
                        this.object[this.name] = "";
                        // this.value = null;
                    }
                } else {
                    this.originalValue = "";
                    this.object[this.name] = "";
                }

            } else {
                this.originalValue = val;
                this.object[this.name] = val;
            }
            // console.log(typeof this.value);
        });

        // ajout pour affecter les valeurs par defaut sans d�tecter un changement
        if (this.defaultValue) {
            this.object[this.name] = this.defaultValue;
        }

        if (!this.formGroup) {
            this.formGroup = new FormGroup({});
        }
        this.formGroup.addControl(this.name, this.formControl);
        if (this.disabled) {
            this.widthClass += " editable-field disabled";
        } else {
            this.widthClass += " editable-field";
        }
        if (this.class) {
            this.widthClass += " " + this.class;
        }
    }

    get errorMessages() {
        let msgs: string[] = [];
        if (!this.formControl.errors || typeof this.formControl.errors != "object") {
            return "";
        }
        for (let i in this.formControl.errors) {
            switch (i) {
                case "email":
                    msgs.push("Email non valide");
                    break;
                case "min":
                    msgs.push("Valeur minimum non atteinte");
                    break;
                case "max":
                    msgs.push("Valeur maximum dépassée");
                    break;
                case "minlength":
                    msgs.push("Nombre de caractères insuffisants");
                    break;
                case "maxlength":
                    msgs.push("Nombre de caractères trop important");
                    break;
                case "pattern":
                    msgs.push("Format non valide");
                    break;
                case "required":
                    msgs.push("Champs requis");
                    break;
            }
        }
        let msg = msgs.join(", ");
        return msg;
    }

    getValidators() {
        let ret : Validators[] = [];
        if (this.required) {
            ret.push(Validators.required);
        }
        if (!this.validators) {
            return ret;
        }
        this.validators.forEach(validator => {
            switch (validator["type"]) {
                case "email":
                    // ret.push(emailOrEmpty);
                    break;
                case "min":
                    ret.push(Validators.min(validator["conf"]));
                    break;
                case "max":
                    ret.push(Validators.max(validator["conf"]));
                    break;
                case "minLength":
                    ret.push(Validators.minLength(validator["conf"]));
                    break;
                case "maxLength":
                    ret.push(Validators.maxLength(validator["conf"]));
                    break;
                case "pattern":
                    ret.push(Validators.pattern(validator["conf"]));
                    break;
            }
        });
        return ret;
    }

  getFullImageUrl(asset) {
    if (!asset || !asset['path']) {
        return null;
    }

    return this.getServerPath() + asset['path'];
  }

  uploadFiles(fileEvent) {
    const formData = new FormData();
    for (let file of fileEvent.files) {
        formData.append('Filedata[]', file);
    }
    this.http
      .post(this.getServerPath() + "asset/add?parentId=8", formData)
      .subscribe((data: any) => {
        this.object[this.name] = data['assets'][0];
      });
  }

  getUploadUrl(url) {
    return this.getServerPath() + "asset/add";
  }

  getServerPath() {
    return environment.apiUrl + '/';
  }
}
